import { render, staticRenderFns } from "./LeavePageDetailsForm.vue?vue&type=template&id=5ae41456&scoped=true&"
import script from "./LeavePageDetailsForm.vue?vue&type=script&lang=js&"
export * from "./LeavePageDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae41456",
  null
  
)

export default component.exports